import MaintenanceBar, { Props } from 'components/gruenland/organisms/maintenance-bar/MaintenanceBar';
import { TasticProps } from '../../types';

const MaintenanceBarTastic = ({ data }: TasticProps<Props>) => {
  return <MaintenanceBar text={data.text} active={data.active} />;
};
export default MaintenanceBarTastic;
